import { render, staticRenderFns } from "./NavPills.vue?vue&type=template&id=149da28c&scoped=true&lang=pug&"
import script from "./NavPills.vue?vue&type=script&lang=js&"
export * from "./NavPills.vue?vue&type=script&lang=js&"
import style0 from "./NavPills.vue?vue&type=style&index=0&id=149da28c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149da28c",
  null
  
)

export default component.exports